/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect }  from 'react';
import {
    bool,
    object,
} from 'prop-types';
import { useQuery } from '@apollo/client';
import mbpLogger from '@module-logger/mbp';
// redux, hooks, helpers
import {  useDispatch, useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import findContent from '../../../../../gql/queries/findContent';
import { GRAPHQL_ENV } from '../../../../../gql';
// import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import GraphqlFindAGiftFast from '../../../GraphqlHomePage/Partials/GraphqlFindAGiftFast/GraphqlFindAGiftFast';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getPageViewFiredState } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Selectors';

const PLAPDPGiftFinderQuery = ({
    brand, plaGiftFinderEnabled,
}) => {
    const { isPlaGiftFinder } = useFlags(); // useSelector(getFeatureFlag('is-pla-gift-finder'));
    const pageView = useSelector(getPageViewFiredState);
    const dispatch = useDispatch();
    useEffect(() => {
        if (plaGiftFinderEnabled && isPlaGiftFinder === true) { // to avoid conflict with loading state
            dispatch(trackEvent({
                eventCategory: 'Experiments',
                eventAction: 'PLA PDP Gift Finder',
                eventLabel: 'Variant',
            }));
        } else if (plaGiftFinderEnabled && isPlaGiftFinder === false) { // to avoid conflict with loading state
            dispatch(trackEvent({
                eventCategory: 'Experiments',
                eventAction: 'PLA PDP Gift Finder',
                eventLabel: 'Control',
            }));
        }
    }, [isPlaGiftFinder, pageView, !isPlaGiftFinder, !pageView]);
    const findPLAIcon = {
        brand: brand['domain-name'],
        contentType: 'gift_finder_universal',
        query: '\\"title\\": \\"PLA Gift Finder\\"',
        GRAPHQL_ENV,
    };
    const PLA_GIFT_FINDER_QUERY = findContent(findPLAIcon);
    const { loading, error, data } = useQuery(PLA_GIFT_FINDER_QUERY, {
        skip: !plaGiftFinderEnabled || !isPlaGiftFinder,
    });
    if (loading) {
        return null;
    }
    if (error) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            query: PLA_GIFT_FINDER_QUERY,
            jsError: error,
            component: 'PLAPDPGiftFinderQuery.js',
            message: `Failed to fetch content data for: content type nup_v3 on brand ${brand}`,
            env: GRAPHQL_ENV,
        });
    }
    if (!data || !data.findContent?.content || !data.findContent.content?.entries
        || !Array.isArray(data.findContent.content.entries)) {
        mbpLogger.logWarning({
            appName: process.env.npm_package_name,
            query: PLA_GIFT_FINDER_QUERY,
            component: 'PLAPDPGiftFinderQuery.js',
            message: 'No data returned for query',
            env: GRAPHQL_ENV,
        });
        return null;
    }

    if (!plaGiftFinderEnabled || !isPlaGiftFinder) { return null; }
    const giftFinderBlock = data?.findContent?.content?.entries || [];

    return (
        <GraphqlFindAGiftFast data={giftFinderBlock?.[0]} isPlaEnabled />
    );
};

PLAPDPGiftFinderQuery.propTypes = {
    brand: object,
    plaGiftFinderEnabled: bool,
};

PLAPDPGiftFinderQuery.defaultProps = { brand: {}, plaGiftFinderEnabled: false };

export default PLAPDPGiftFinderQuery;
